import { render, staticRenderFns } from "./HelperTextButton.vue?vue&type=template&id=37444c31&"
import script from "./HelperTextButton.vue?vue&type=script&lang=js&"
export * from "./HelperTextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports